import { termsData } from './data';
import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import Navbar from '../../../MainScreen/components/navbar';
import Footer from '../../../MainScreen/components/footer';
import { useRef } from 'react';

const TermsAndConditions = () => {
  const classes = useStyles();
  const aboutRef = useRef<HTMLDivElement | null>(null);
  const HIWRef = useRef<HTMLDivElement | null>(null);
  const FAQRef = useRef<HTMLDivElement | null>(null);
  const homeRef = useRef<HTMLDivElement | null>(null);

  return (
    <Box id="scroll-container" sx={{ height: '100vh', overflow: 'scroll' }}>
      <Box className={classes.hero}>
        <Navbar aboutRef={aboutRef} HIWRef={HIWRef} FAQRef={FAQRef} HomeRef={homeRef} />
        <Typography variant="h4" className={classes.heroTitle}>
          Terms and Conditions
        </Typography>
      </Box>

      <Box sx={{ background: 'white', width: '100%', display: 'flex', justifyContent: 'center', position: 'relative', zIndex: 50 }}>
        <Box className={classes.contentContainer}>
          {termsData.map((item, idx) => (
            <Box key={idx} className={classes.section}>
              <Typography variant="h6" className={classes.title}>
                {item.title}
              </Typography>
              <Typography className={classes.content} component="div" dangerouslySetInnerHTML={{ __html: item.content || '' }} />
            </Box>
          ))}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default TermsAndConditions;
